export enum FindLocationSortOptions {
    None = 0,
    IdAscending = 1,
    IdDescending = 2,
    CityAscending = 3,
    CityDescending = 4
}
